// AdPixelsTracker — mounts inside BrowserRouter; loads the consent-gated
// TikTok/Meta pixels and reports one PageView per SPA route change.
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initAdPixels, adTrackPageView } from '../lib/adPixels';
import { captureAcquisition } from '../lib/acquisition';

export default function AdPixelsTracker() {
  const location = useLocation();
  const firstRoute = useRef(true);

  useEffect(() => {
    // First-party UTM capture — independent of the consent-gated pixels.
    captureAcquisition();
    initAdPixels();
    const onConsent = () => initAdPixels();
    window.addEventListener('fws:consent-changed', onConsent);
    return () => window.removeEventListener('fws:consent-changed', onConsent);
  }, []);

  useEffect(() => {
    // Base snippets already fire the initial PageView on load.
    if (firstRoute.current) { firstRoute.current = false; return; }
    adTrackPageView();
  }, [location.pathname]);

  return null;
}
